export default __webpack_public_path__ + "static/contact-company-0e1c77ff25f29bd48181eb5b40d0339e.png";